var salirRapido = function () {
    var boton = document.querySelector('#salir-rapido');
    if (!boton) {
        return;
    }
    addEventListener('keydown', function (e) {
        var target = e.target;
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
            return;
        }
        if (e.key === 'q') {
            boton.click();
        }
    });
    var ajustaPosicion = function () {
        document.documentElement.style.setProperty('--salir-rapido-bottom', "".concat(boton.getBoundingClientRect().bottom + scrollY, "px"));
    };
    addEventListener('resize', ajustaPosicion);
    addEventListener('load', ajustaPosicion);
    ajustaPosicion();
};
export default salirRapido;
